import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Preview from '@/views/Preview'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/en',
      name: 'english',
      component: Home
    },
    {
      path: '/preview',
      name: 'preview',
      component: Preview
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})
